@import '~@customink/design-tokens/build/scss/variables.scss';
@import '../../global-styles/index.scss';

#productOverlay, #apparelProductOverlay {
  height: 470px;
}
#promoProductOverlay {
  height: 500px;
}
.ciProducts {
  display: flex;
  padding: $spacing-16;
  align-items: flex-start;

  .ghf-menu-link {
    border-radius: 6px;
    padding: .5rem;
    display: block;
    &:hover {
      background: $color-header-hover-blue;
    }
  }
  &-heading {
    padding: .5rem;
    display: block;
    color: $color-red-default !important;
    font-size: 14px;
    font-weight: 700;
    text-transform: uppercase;
    &.ghf-menu-link:hover {
      background: transparent;
      color: #ce1400 !important;
    }
  }

  &-column {
    display: flex;
    flex-direction: column;
    flex: 1 0 0;

    &-list {
      margin: 0;
      margin-block: 0;
      padding-inline: 0;
      list-style-type: none;
      padding: 0 $spacing-8 $spacing-16 $spacing-8;
      line-height: 1rem;
      .ghf-menu-listItem {
        display: block;
        padding: 0;
      }
    }
  }

  &-new {
    display: flex;
    gap: 10px;
    padding: 0 $spacing-8;
    align-items: center;
  }

  &-inlineImage {
    width: 25px;
    display: inline-block;
    position: relative;
    padding: 0 0 0 3px;
    vertical-align: middle;
  }

  &-moreWaysToShop-icon {
    display: flex;
    gap: 5px;
    align-items: center;

    .ciProducts-inlineImage {
      width: 20px;
    }
  }
}
// special override
.ciProducts-heading--newArrivals {
  .ghf-menu-listItem {
    padding-left: 0;
    padding-top: 0;
  }
}
